import { render, staticRenderFns } from "./ArchivedStockMovements.vue?vue&type=template&id=5de05686&scoped=true&"
import script from "./ArchivedStockMovements.vue?vue&type=script&lang=ts&"
export * from "./ArchivedStockMovements.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivedStockMovements.vue?vue&type=style&index=0&id=5de05686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de05686",
  null
  
)

export default component.exports